import script from "./ViewDoc.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewDoc.vue?vue&type=script&setup=true&lang=ts"

import "./ViewDoc.vue?vue&type=style&index=0&id=0a4016ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4016ea"]])

export default __exports__